export default {
  es: {
    'app.tipos-inmuebles.index.column.active.false': 'inactivo',
    'app.tipos-inmuebles.index.column.active.true': 'activo',
    'app.tipos-inmuebles.index.column.active': 'Activo',
    'app.tipos-inmuebles.index.column.id': 'ID',
    'app.tipos-inmuebles.index.column.name': 'Nombre',
    'app.tipos-inmuebles.index.column.created_at': 'Fecha de creación',
    'app.tipos-inmuebles.index.title': 'Listado de los tipos de inmuebles',
  },
};